<div class="modal-header">
    <h6 class="modal-title" id="modal-basic-title" *ngIf="options?.heading">
        {{(options.heading || '') | translate}}
    </h6>
    <button type="button" class="close" aria-label="Close" (click)="close()">
        <span aria-hidden="true">×</span>
    </button>
</div>
<div class="modal-body">
    <div class="bg-form-content p-4">
        <div class="form-group">
            <label>{{"Verification Code"|translate}}</label>
            <ng-otp-input [(ngModel)]="otp.value" [config]="otpConfig" (onInputChange)="onOTPChange()"></ng-otp-input>
            <div class="text-muted">
                <small *ngIf="otp.countdown > 0">
                    {{"Didn't get the OTP?"|translate}} {{ "Resend in" | translate }} {{ otp.countdown }}s
                </small>
                <a href="javascript:void(0)" *ngIf="otp.countdown === 0" (click)="sendCode()">
                    <small>{{ "Resend OTP" | translate }}</small>
                </a>
            </div>
            <div>
                <small class="form-error text-danger" *ngIf="otp?.messageData?.errorArr?.length">
                    <div *ngFor="let item of otp?.messageData?.errorArr; let i=index;" class="mt-3">
                        <li>{{item}}</li>
                    </div>
                </small>
                <small class="lms-text-light-green" *ngIf="otp?.messageData?.verified">
                    <li class="fs-15">
                        {{otp.messageData.verified}}
                    </li>
                </small>
            </div>
            <div class="mt-3">
                <button class="btn btn-primary btn-block text-uppercase"
                    [disabled]="!otp.value || (otp.value && otp.value.length!==6)" (click)="verifyCode()">
                    {{"Verify Code"|translate}}
                </button>
            </div>
        </div>
    </div>
</div>